<template>
  <span class="ml-25 mr-50 like-button" role="button" @click.stop="handleToggleLike">
    <span v-if="liked" class="profile-likes-primary">
      <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="filledColor"
        :stroke="filledColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-heart profile-icon mr-25"
        style="display: inline-block; vertical-align: middle;"
      >
        <path d="M20.8 4.6c-1.5-1.4-3.9-1.4-5.4 0l-.4.4-.4-.4c-1.5-1.4-3.9-1.4-5.4 0-1.6 1.5-1.6 4 0 5.5l5.8 5.7 5.8-5.7c1.6-1.5 1.6-4 0-5.5z"></path>
      </svg>
    </span>
    <svg
      v-else
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      :fill="'none'"
      :stroke="outlineColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-heart profile-icon mr-25"
      style="display: inline-block; vertical-align: middle;"
    >
      <path d="M20.8 4.6c-1.5-1.4-3.9-1.4-5.4 0l-.4.4-.4-.4c-1.5-1.4-3.9-1.4-5.4 0-1.6 1.5-1.6 4 0 5.5l5.8 5.7 5.8-5.7c1.6-1.5 1.6-4 0-5.5z"></path>
    </svg>
    <span>
      {{ count }}
    </span>
    <span v-if="showText && !liked" class="like-text">
      {{ $t ? $t('forums.icons.like') : 'Like' }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LikeButton',
  props: {
    liked: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 20,
    },
    filledColor: {
      type: String,
      default: '#e3342f',
    },
    outlineColor: {
      type: String,
      default: '#6c757d', // Bootstrap secondary
    },
    showText: {
      type: Boolean,
      default: false,
    },
    itemType: {
      type: String,
      required: true,
    },
    morphType: {
      type: String,
      default: undefined,
    },
    itemKey: {
      type: [String, Number],
      required: true,
    },
    storedKey: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    async handleToggleLike() {
      await this.$store.dispatch('toggleLike', {
        itemType: this.itemType,
        morphType: this.morphType,
        key: this.itemKey,
        storedKey: this.storedKey,
      });
      this.$emit('toggled');
    },
  },
};
</script>

<style scoped>
.like-button {
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
}
.like-text {
  margin-left: 4px;
  font-size: 1em;
}
</style> 